import { apiClient, getUserId } from "./authService";

interface VenueData {
  [key: string]: any;
}

function toFormDataIfNeeded(payload: VenueData): VenueData | FormData {
  const hasFile = Object.values(payload).some(
    (value) => value instanceof File || value instanceof Blob
  );
  if (!hasFile) return payload;
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    formData.append(key, value as any);
  });
  return formData;
}

export const getAllVenues = async (): Promise<any> => {
  try {
    const url = `/venue/user-venues`;
    const response = await apiClient.get(url);

    const data: any = response.data;
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (Array.isArray(data.venues)) return data.venues;
    if (Array.isArray(data.data)) return data.data;
    const firstArray = Object.values(data).find((v) => Array.isArray(v));
    return Array.isArray(firstArray) ? firstArray : [];
  } catch (error) {
    throw error;
  }
};

export const createVenue = async (venueData: VenueData): Promise<any> => {
  try {
    const userId = getUserId();
    const payload = { ...(venueData || {}) } as VenueData;
    if (!payload.user_id && userId) payload.user_id = userId;

    const body = toFormDataIfNeeded(payload);
    const response = await apiClient.post("/venue/create", body as any);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateVenue = async (
  id: string,
  venueData: VenueData
): Promise<any> => {
  try {
    const payload = { ...(venueData || {}) } as VenueData;
    const body = toFormDataIfNeeded(payload);
    const response = await apiClient.put(`/venue/${id}`, body as any);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteVenue = async (
  id: string,
  data: { password: string }
): Promise<any> => {
  try {
    const response = await apiClient.delete(`/venue/${id}`, { data } as any);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const hasFifteenMinuteSlots = async (
  venueId: string | number
): Promise<boolean> => {
  try {
    const response = await apiClient.get(
      `/venue/${venueId}/has-slot-duration-15`
    );
    const payload: any = response?.data;

    if (typeof payload === "boolean") return payload;
    if (payload && typeof payload.data === "boolean") return payload.data;
    if (payload && typeof payload.result === "boolean") return payload.result;
    if (payload && typeof payload.hasSlotDuration15 === "boolean")
      return payload.hasSlotDuration15;

    return false;
  } catch (error) {
    throw error;
  }
};
